var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appointment"},[(_vm.canvsShow)?_c('handwriting',{staticClass:"handwritings",attrs:{"fromRoute":_vm.fromRoute},on:{"func":_vm.getMsgFormSon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }